const monthsInYear = {
  0: 'January',
  1: 'February',
  2: 'March',
  3: 'April',
  4: 'May',
  5: 'June',
  6: 'July',
  7: 'August',
  8: 'September',
  9: 'October',
  10: 'November',
  11: 'December'
};

export const dateToStringFormat = (date: Date): string => {
  return `${monthsInYear[date.getMonth()]} ${date.getDate()} ${date.getFullYear()}`;
};

export const formatDate = (timestamp: Date | string): string => {
  const date: Date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;
  return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};
